import instObj from '@/backend/axios-instances'

const resource = "/orders/detail"
const instance = instObj.baseInstance

export default {
  get(orderDetailId, parameters) {
    return instance.get(`${resource}/${orderDetailId}`, { params: parameters });
  },
  put(orderDetailId, data, parameters) {
    return instance.put(`${resource}/${orderDetailId}`, data, { params: parameters });
  },
  delete(orderDetailId) {
    return instance.delete(`${resource}/${orderDetailId}`);
  }
}
